// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// D-CRX-87 §2 — the words the pharmacy reads when its SaaS admin set a CareRx "Rx start date".

import { formatUsDate, formatUsDateLocal } from '../api/format'

export interface RxStartInfo {
  rx_start_date?: string | null
  rx_start_set_by?: string | null
  rx_start_set_at?: string | null
  before_start_count?: number | null
}

/** The PA feed's line: "N Rx before start date MM-DD-YYYY — not shown (set by X on MM-DD-YYYY)". Null when no start date. */
export function beforeStartLine(info: RxStartInfo | null | undefined): string | null {
  if (!info?.rx_start_date) return null
  const n = info.before_start_count
  const count = n == null ? 'Some' : n.toLocaleString()
  const who = info.rx_start_set_by ?? 'a SaaS admin'
  const when = info.rx_start_set_at ? ` on ${formatUsDateLocal(info.rx_start_set_at)}` : ''
  return `${count} Rx before start date ${formatUsDate(info.rx_start_date)} — not shown (set by ${who}${when})`
}

/** The door picker's note under a greyed Rx list. */
export function pickerStartNote(startDate: string | null | undefined): string | null {
  if (!startDate) return null
  return `Greyed: written before this pharmacy's CareRx start date (${formatUsDate(startDate)}). They can still be picked.`
}
